import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core";
import MaterialTable from 'material-table'
import * as i18n from "../common/i18n";
import Message from "./Message";
import * as graphql from '../common/graphql';
import gql from 'graphql-tag';
import * as helper from "../common/helper"
import { reactLocalStorage } from 'reactjs-localstorage';
import { CsvBuilder } from 'filefy';
import LinearProgress from '@material-ui/core/LinearProgress';
import { withIAM } from "../common/iam";
import moment from "moment-timezone";
import RouterIcon from '@material-ui/icons/Router';
import Chip from '@material-ui/core/Chip';
import ChipLink from '../components/ChipLink';


const styles = theme => ({
});

const defaults = {
    id: false,
    details: false,
    type: false,
    created: false,
    site: false,
    firmware: false,
    pageSize: 5,
};


const FindingTypes = {
    "UNPLAUSIBLE_LASTEST_MEASUREMENT_POINTS_LO": i18n.get("quality.findingType.UNPLAUSIBLE_LASTEST_MEASUREMENT_POINTS_LO"),
    "UNPLAUSIBLE_LASTEST_MEASUREMENT_POINTS_HI": i18n.get("quality.findingType.UNPLAUSIBLE_LASTEST_MEASUREMENT_POINTS_HI"),
    "UNPLAUSIBLE_LASTEST_MEASUREMENT_ML_NULL": i18n.get("quality.findingType.UNPLAUSIBLE_LASTEST_MEASUREMENT_ML_NULL"),
    "UNPLAUSIBLE_LASTEST_MEASUREMENT_ML_LO": i18n.get("quality.findingType.UNPLAUSIBLE_LASTEST_MEASUREMENT_ML_LO"),
    "UNPLAUSIBLE_LASTEST_MEASUREMENT_ML_HI": i18n.get("quality.findingType.UNPLAUSIBLE_LASTEST_MEASUREMENT_ML_HI"),
    "UNPLAUSIBLE_LASTEST_MEASUREMENT_MAX_DISTANCE_NULL": i18n.get("quality.findingType.UNPLAUSIBLE_LASTEST_MEASUREMENT_MAX_DISTANCE_NULL"),
    "UNPLAUSIBLE_LASTEST_MEASUREMENT_MIN_DISTANCE_NULL": i18n.get("quality.findingType.UNPLAUSIBLE_LASTEST_MEASUREMENT_MIN_DISTANCE_NULL"),
    "UNPLAUSIBLE_LASTEST_MEASUREMENT_DISTANCE_HI": i18n.get("quality.findingType.UNPLAUSIBLE_LASTEST_MEASUREMENT_DISTANCE_HI"),
    "UNPLAUSIBLE_LASTEST_MEASUREMENT_DISTANCE_LO": i18n.get("quality.findingType.UNPLAUSIBLE_LASTEST_MEASUREMENT_DISTANCE_LO"),
    "UNPLAUSIBLE_LASTEST_MEASUREMENT_VARIANCE_HI": i18n.get("quality.findingType.UNPLAUSIBLE_LASTEST_MEASUREMENT_VARIANCE_HI"),
    "UNPLAUSIBLE_LASTEST_MEASUREMENT_VARIANCE_LO": i18n.get("quality.findingType.UNPLAUSIBLE_LASTEST_MEASUREMENT_VARIANCE_LO"),
    "TESTFLUSHES_ONLY": i18n.get("quality.findingType.TESTFLUSHES_ONLY"),
}

const DeviceStatus = {
    "LEASED": i18n.get("devices.status.LEASED"),
    "DEFECTIVE": i18n.get("devices.status.DEFECTIVE"),
    "MAINTENANCE": i18n.get("devices.status.MAINTENANCE"),
    "STOCKED": i18n.get("devices.status.STOCKED"),
    "ASSEMBLY": i18n.get("devices.status.ASSEMBLY"),
}

const defaultsPropertyName = 'p71.quality.defaults';

class DevicesFindings extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            message: null,
            details: null,
            hideAfter: 3000,
            variant: "info",
            exporting: false,
            progressValue: 0,
            userSettings: reactLocalStorage.getObject(props.defaultsPropertyName, defaults)
        };

        this.tableRef = React.createRef();
    }

    default(id) {
        return this.state.userSettings[id] !== undefined ? this.state.userSettings[id] : defaults[id];
    }

    setDefault(id, value) {

        const newUserSettings = { ...this.state.userSettings };
        newUserSettings[id] = value;

        this.setState({ userSettings: newUserSettings }, () => {
            reactLocalStorage.setObject(this.props.defaultsPropertyName, newUserSettings);
        });
    }

    showMessage = (message, variant, details, hideAfter) => {
        this.setState({
            message: message,
            variant: variant ? variant : "info",
            hideAfter: hideAfter ? hideAfter : 3000,
            details: details ? details : null,
        })
    }

    closeMessage = () => {
        this.setState({
            message: null,
            details: null,
            hideAfter: 3000,
            variant: "info",
        })
    }

    mapField(column) {
        return column;
    }

    exportCsv = async (columns, data) => {

        try {

            this.setState({
                exporting: true,
                progressValue: 0
            });

            this.showMessage("Export wird angestoßen. Bitte verlassen Sie die Seite nicht, solange der Exportvorgang läuft. Das Erstellen eines Exports bei sehr vielen Auffälligkeiten kann mehrere Minuten dauern.", "info");

            const direction = "ASC";
            const sort = "ref";

            const allFindings = [];
            let totalCount = 0;
            const first = 200;
            let offset = 0;

            do {

                const filters = []
                for (const column of columns) {
                    if (column.tableData.filterValue !== undefined) {
                        filters.push({
                            column: column,
                            field: column.field,
                            type: column.type,
                            comparator: column.comparator,
                            value: column.tableData.filterValue
                        })
                    }
                }

                const find = helper.whereString(filters, this.mapField, ["ref"]);

                const result = await graphql.clientWithToken(this.props.accessToken).query({
                    query: gql`
                    query {
                        findings(subject: DEVICES first: ${first}, offset: ${offset}, orderBy:[{column: "${sort}", direction: ${direction}}], where:${find}) {
                            totalCount
                            elements {
                                ... on Finding {
                                    ref,
                                    type,
                                    status,
                                    created {
                                        X
                                    },
                                    details
                                    site
                                    firmware
                                    battery
                               }
                            }
                        }
                    }
                `,
                    fetchPolicy: "no-cache"
                });

                totalCount = result.data.findings.totalCount;
                offset = offset + first;
                let detail;
                for (const finding of result.data.findings.elements) {
                    const details = JSON.parse(finding["details"]);
                    switch (finding["type"]) {
                        case "LOW_BATTERY":
                            detail = `Batterieladung bei ${details["battery"]}%`;
                            break;
                        case "LATE_RESPONSE":
                            detail = `Tatsächlich: ${moment(details["latest"], 'X').tz('Europe/Berlin').format('DD.MM.YYYY HH:mm')}, erwartet: ${moment(details["expected"], 'X').tz('Europe/Berlin').format('DD.MM.YYYY HH:mm')}`;
                            break;
                        case "UNPLAUSIBLE_LASTEST_MEASUREMENT_POINTS_LO":
                            detail = `nur ${details["numPoints"]} von erwarteten ${details["expectedPoints"]} Punkten`
                            break;
                        case "UNPLAUSIBLE_LASTEST_MEASUREMENT_POINTS_HI":
                            detail = `${details["numPoints"]} statt ${details["expectedPoints"]} Punkte`
                            break;
                        case "UNPLAUSIBLE_LASTEST_MEASUREMENT_ML_NULL":
                            detail = `kein Durchfluss`
                            break;
                        case "UNPLAUSIBLE_LASTEST_MEASUREMENT_ML_LO":
                            detail = `nur ${details["actual"]} ml von erwarteten ${details["expected"]} ml`
                            break;
                        case "UNPLAUSIBLE_LASTEST_MEASUREMENT_ML_HI":
                            detail = `${details["actual"]} ml statt ${details["expected"]} ml`
                            break;
                        case "UNPLAUSIBLE_LASTEST_MEASUREMENT_MAX_DISTANCE_NULL":
                            detail = `größte gemessene Entfernung ist 0 mm`
                            break;
                        case "UNPLAUSIBLE_LASTEST_MEASUREMENT_MIN_DISTANCE_NULL":
                            detail = `kleinste gemessene Entfernung ist 0 mm`
                            break;
                        case "UNPLAUSIBLE_LASTEST_MEASUREMENT_DISTANCE_HI":
                            detail = `${details["distMax"]} mm gemessen`
                            break;
                        case "UNPLAUSIBLE_LASTEST_MEASUREMENT_DISTANCE_LO":
                            detail = `${details["distMin"]} mm gemessen`
                            break;
                        case "UNPLAUSIBLE_LASTEST_MEASUREMENT_VARIANCE_HI":
                            detail = `Maximum: ${details["distMax"]}, Durchschnitt: ${details["distMean"]}`
                            break;
                        case "UNPLAUSIBLE_LASTEST_MEASUREMENT_VARIANCE_LO":
                            detail = `Minimum: ${details["distMin"]}, Durchschnitt: ${details["distMean"]}`
                            break;
                        default:
                            detail = finding.details
                    }
                    allFindings.push(
                        {
                            ref: finding.ref,
                            type: finding.type,
                            status: finding.status,
                            created: finding.created && finding.created.X ? moment(finding.created.X, 'X').format('DD.MM.YYYY HH:mm') : null,
                            details: detail,
                            site: finding.site,
                            firmware: finding.firmware,
                            battery: finding.battery,
                        }
                    )
                }

                if (totalCount != 0) {
                    this.setState({
                        exporting: true,
                        progressValue: (allFindings.length / totalCount) * 100
                    });
                }
            } while (allFindings.length < totalCount);

            const builder = new CsvBuilder('Auffälligkeiten.csv')
                .setDelimeter(";")
                .setColumns(columns.map(columnDef => columnDef.title))
                .addRows(allFindings.map(finding => { return [finding.ref, FindingTypes[finding.type], DeviceStatus[finding.status], finding.created, finding.firmware, finding.battery, finding.site, finding.details] }))
                .exportFile();

            this.setState({
                exporting: false,
                progressValue: 0
            });
        } catch (error) {
            this.setState({
                exporting: false,
                progressValue: 0
            });
            this.showMessage(error.message, "error");
        }

    }

    render() {

        return (
            <div style={{ maxWidth: '100%' }}>
                {this.state.exporting && <div style={{ width: "100%" }}><LinearProgress value={this.state.progressValue} variant={"determinate"} /></div>}
                <MaterialTable
                    components={{
                        Cell: helper.defaultCell,
                        FilterRow: helper.defaultFilter
                    }}
                    icons={helper.tableIcons}
                    onChangeRowsPerPage={pageSize => { this.setDefault("pageSize", pageSize) }}
                    onChangeColumnHidden={data => { this.setDefault(data["field"], data["hidden"]) }}
                    tableRef={this.tableRef}
                    localization={i18n.getLocalization(
                        this.props.materialTableCustomLocalization
                    )}
                    columns={[
                        {
                            title: i18n.get("quality.ref"),
                            field: 'ref',
                            hidden: this.default("ref"),
                            cellStyle: {
                                minWidth: '100px',
                                maxWidth: '100px',
                            },
                            headerStyle: {
                                minWidth: '100px',
                                maxWidth: '100px',
                            },
                            render: (rowData) => {
                                if (rowData) {
                                    return <ChipLink
                                        icon={<RouterIcon />}
                                        link={{ page: i18n.get('menus.devices'), data: { uuid: rowData.ref } }}
                                        key={rowData.ref}
                                        label={`${rowData.ref}`}
                                        style={{ marginRight: 8, marginBottom: 8 }}
                                    />
                                }
                            },
                        },
                        {
                            title: i18n.get("quality.type"),
                            field: 'type',
                            lookup: FindingTypes,
                            hidden: this.default("type"),
                            cellStyle: {
                                minWidth: '400px',
                                maxWidth: '400px',
                            },
                            headerStyle: {
                                minWidth: '400px',
                                maxWidth: '400px',
                            },
                        },
                        {
                            title: i18n.get("quality.status"),
                            field: 'status',
                            lookup: DeviceStatus,
                            hidden: this.default("status"),
                            cellStyle: {
                                minWidth: '300px',
                                maxWidth: '300px',
                            },
                            headerStyle: {
                                minWidth: '300px',
                                maxWidth: '300px',
                            },
                        },
                        {
                            title: i18n.get("quality.created"),
                            field: 'created',
                            type: "datetime",
                            filtering: true,
                            sorting: true,
                            cellStyle: {
                                minWidth: '400px',
                                maxWidth: '400px',
                            },
                            headerStyle: {
                                minWidth: '400px',
                                maxWidth: '400px',
                            },
                            filterComponent: helper.DateRangeFilter,
                            hidden: this.default("created")
                        },
                        {
                            title: i18n.get("quality.firmware"),
                            field: 'firmware',
                            hidden: this.default("firmware"),
                            cellStyle: {
                                minWidth: '200px',
                                maxWidth: '200px',
                            },
                            headerStyle: {
                                minWidth: '200px',
                                maxWidth: '200px',
                            },
                            sorting: true,
                            filtering: true,
                        },
                        {
                            title: i18n.get("quality.battery"),
                            field: 'battery',
                            hidden: this.default("battery"),
                            sorting: true,
                            filtering: true,
                            type: 'numeric',
                            cellStyle: {
                                minWidth: '275px',
                                maxWidth: '275px',
                            },
                            headerStyle: {
                                minWidth: '275px',
                                maxWidth: '275px',
                            },
                            render: (rowData) => rowData && rowData.battery ? `${rowData.battery} %` : null,
                            filterComponent: helper.RangeFilter
                        },
                        {
                            title: i18n.get("quality.site"),
                            field: 'site',
                            hidden: this.default("site"),
                            cellStyle: {
                                minWidth: '400px',
                                maxWidth: '400px',
                            },
                            headerStyle: {
                                minWidth: '400px',
                                maxWidth: '400px',
                            },
                            sorting: true,
                            filtering: true,
                        },
                        {
                            title: i18n.get("quality.details"),
                            field: 'details',
                            hidden: this.default("details"),
                            cellStyle: {
                                minWidth: '500px',
                                maxWidth: '500px',
                            },
                            headerStyle: {
                                minWidth: '500px',
                                maxWidth: '500px',
                            },
                            filtering: false,
                            sorting: false,
                            render: rowData => {
                                return helper.findingDetailsOf(rowData)
                            }
                        }
                    ]}
                    title={i18n.get("quality.title")}
                    options={{
                        exportButton: !this.state.exporting,
                        filtering: true,
                        showTitle: false,
                        debounceInterval: 1000,
                        search: false,
                        columnsButton: true,
                        exportCsv: this.exportCsv,
                        pageSize: this.default("pageSize")
                    }}
                    data={query =>
                        new Promise(async (resolve, reject) => {

                            try {
                                const direction = query["orderDirection"] === "desc" ? "DESC" : "ASC";
                                const orderBy = helper.orderByString(query, this.mapField, "created", query["orderBy"] && query["orderBy"]["field"] === "ref")

                                const where = helper.whereString(query["filters"], this.mapField, ["ref"]);

                                if (query["orderBy"] && query["orderBy"]["field"] === "ref" && where === "[]") {
                                    where = '[{column: "created", comparator: GT, datetime: -1}]'
                                }

                                const result = await graphql.clientWithToken(this.props.accessToken).query({
                                    query: gql`
                                    query {
                                        findings(subject: DEVICES first: ${query.pageSize}, offset: ${query.pageSize * query.page}, orderBy:${orderBy}, where:${where}) {
                                            totalCount
                                            elements {
                                                ... on Finding {
                                                    ref,
                                                    type,
                                                    status,
                                                    created {
                                                        X
                                                    },
                                                    details
                                                    site
                                                    firmware
                                                    battery
                                               }
                                            }
                                        }
                                    }
                                `,
                                    fetchPolicy: "no-cache"
                                });

                                resolve({
                                    page: query.page,
                                    data: result.data.findings.elements.map((element) => {
                                        return {
                                            ref: element.ref,
                                            type: element.type,
                                            status: element.status,
                                            created: element.created && element.created.X ? moment(element.created.X, 'X').toDate() : null,
                                            details: element.details,
                                            site: element.site,
                                            firmware: element.firmware,
                                            battery: element.battery
                                        };
                                    }),
                                    totalCount: result.data.findings.totalCount
                                });
                            } catch (error) {
                                this.showMessage(error.message, "error");
                                reject(error);
                            }
                        })
                    }
                />

                <Message
                    hideAfter={this.state.hideAfter}
                    onClose={this.closeMessage}
                    variant={this.state.variant}
                    message={this.state.message}
                    details={this.state.details}
                    open={this.state.message !== null}
                />
            </div>
        )
    }
}

DevicesFindings.propTypes = {
    classes: PropTypes.object.isRequired,
    subject: PropTypes.string.isRequired,
};

export default withIAM(withStyles(styles, { withTheme: true })(DevicesFindings))